import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { Viewer } from "../../../../widgets/Viewer";

import { loadDonations, deleteDonation } from '../../../../../redux/actions/donation.actions';
import { Spinner } from '@blueprintjs/core';

class DonorHeader extends Component {
    render() {
        return (
            <div className="panel-title">
                <span className="panel-title-flex">
                    <h4>All Donor Donations</h4>
                </span>
                <span className="panel-title-fixed">
                    <button type="button"
                        className="pt-button pt-small pt-intent-primary pt-icon-add"
                        onClick={(event) => this.props.openModal({ event, rowData: null })}>
                        Add Donation
                    </button>
                </span>
            </div>
        );
    }
}

const EmptyView = props => {
    return (
        <div className="intro">
            <div className="intro-text">Click here to add a donation. <span onClick={(event) => props.openModal({ event, rowData: null })} className="link">Add Donation</span></div>
        </div>
    );
};

class DonorDonations extends Component {
    componentDidMount() {
        this.loadData();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.donorId !== this.props.donorId) {
            this.loadData(nextProps);
        }
    }
    loadData = async (props = this.props) => {
        const { donorId } = props;
        props.loadDonations(donorId);
    }
    openModal = ({ rowData, event }) => {
        event.preventDefault();
        event.stopPropagation();
        const { donorId } = this.props;
        const form = rowData ? { ...rowData, donorId } : { donorId };
        const customEvent = new CustomEvent(('open-add-donation-modal'), { detail: form });
        window.dispatchEvent(customEvent);
    }
    deleteRow = ({ event, donation }) => {
        event.preventDefault();
        event.stopPropagation();
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: 'Are you sure you want to delete this donation?',
                onDelete: () => {
                    this.props.deleteDonation({ donationId: donation.id, donorId: donation.donor_id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { donationState, recipientState } = this.props;
        const { donations, allLoading } = donationState;
        const { recipientsById } = recipientState;
        return (
            <Fragment>
                <DonorHeader openModal={this.openModal} />
                <div className="panel-progress panel-content">
                    { allLoading ? 
                        <div className="spinner-container">
                            <Spinner large />
                        </div> :
                        donations.length === 0 ?
                            <EmptyView openModal={this.openModal} /> :
                            <table className="general-table pt-html-table pt-interactive">
                                <thead>
                                    <tr>
                                        <th>Target Recipient</th>
                                        <th>Amount</th>
                                        <th>Donation Date</th>
                                        <th>Notes</th>
                                        <th>Preview</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { donations.map((donation, i) => {
                                        const recipient = donation.recipient_id ? recipientsById[donation.recipient_id] : null;
                                        return (
                                            <tr key={i} onClick={(event) => this.openModal({ rowData: donation, event })}>
                                                <td>{recipient ? `${recipient.first_name} ${recipient.middle_name} ${recipient.last_name}` : 'None'}</td>
                                                <td>${donation.amount} ({donation.currency})</td>
                                                <td>{moment(donation.donation_date).format('ddd, MMM Do, YYYY')}</td>
                                                <td>{donation.notes}</td>
                                                <td onClick={e => e.stopPropagation()}>
                                                    <Viewer src={donation.image || donation.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
                                                </td>
                                                <td className="action-row">
                                                    <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => this.deleteRow({ donation, event })}>Delete</div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                    }
                </div>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    donationState: state.donation,
    recipientState: state.recipient
});

export default withRouter(connect(
    mapStateToProps,
    { loadDonations, deleteDonation }
)(DonorDonations));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/donor/DonorDonations.jsx